import React from "react";
import POList from "../po-list";

const VendorPos = () => {
  return (
    <div>
      {" "}
      <POList status="approved" />
    </div>
  );
};

export default VendorPos;
